import { Chip, SxProps, Theme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { baseColors, CLOUD_BASE_PATH } from 'utils/constants';

type Props = {
  sx?: SxProps<Theme> | undefined;
};

const RequiredChip = ({ sx }: Props) => {
  const { pathname } = useLocation();
  const isCloud = pathname.startsWith(CLOUD_BASE_PATH);

  return (
    <Chip
      label="必須"
      size="small"
      sx={{
        p: 0,
        bgcolor: isCloud ? baseColors.cloudPink : baseColors.red,
        color: baseColors.white,
        fontSize: '14px',
        fontWeight: 'normal',
        borderRadius: 1,
        ...sx
      }}
    />
  );
};

export default RequiredChip;
